import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import './TabMenu.css'

const TabMenu = ({ selected, children, sendIndex }) => {
  const handleClick = (event, index) => {
    event.preventDefault()
    sendIndex(index)
  }
  const _renderContent = (selected, children) => {
    return <div styleName="tabsContent">{children[selected]}</div>
  }
  const labels = (child, index) => {
    let activeClass = selected == index ? 'tabs_li active' : 'tabs_li'
    return (
      <li key={index} styleName={activeClass}>
        <div role="tab" onClick={e => handleClick(e, index)} styleName="tab">
          <p styleName="tabText">{child.props.label}</p>
        </div>
      </li>
    )
  }
  const _renderTitles = (selected, children) => {
    return <ul styleName="tabs_labels">{children.map((child, index) => labels(child, index))}</ul>
  }
  return (
    <div className="tabs">
      {_renderTitles(selected, children)}
      {_renderContent(selected, children)}
    </div>
  )
}

TabMenu.propTypes = {
  selected: PropTypes.number,
  children: PropTypes.array,
  handleChange: PropTypes.func,
  sendIndex: PropTypes.func
}

export default compose(pure)(TabMenu)
